import { render, staticRenderFns } from "./BillAddIncome.vue?vue&type=template&id=490aa0c4&scoped=true"
import script from "./BillAddIncome.vue?vue&type=script&lang=js"
export * from "./BillAddIncome.vue?vue&type=script&lang=js"
import style0 from "./BillAddIncome.vue?vue&type=style&index=0&id=490aa0c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490aa0c4",
  null
  
)

export default component.exports